export default {
    title: 'Contact',
    'placeholder': 'Contate-Nos!',
    // add other fields

    'submit': 'Enviar',
  };
  